import styled from "styled-components";

export const UserCardWrapper = styled.div`
  width: 100%;
  background-color: #FDFDFE;
  padding: 2rem 1rem;
  box-shadow: 0 3px 15px 0 rgba(79, 104, 145, 0.1);
  -webkit-box-shadow: 0 3px 15px 0 rgba(79, 104, 145, 0.1);
  -moz-box-shadow: 0 3px 15px 0 rgba(79, 104, 145, 0.1);
  border-radius: 20px;
  margin-bottom: 2.2rem;
  
  .call {
    position: absolute;
    left: 10px;
    top: 12px;
    
    &::before {
      font-size: 1.2rem;
    }
  }

  ${props => props.status === 'reject' && {
    cursor: 'not-allowed',
    backgroundColor: 'rgba(118,133,155,0.4)',
    img: {
      filter: 'grayscale(1)'
    },
    p: {
      color: '#FFFFFF !important',
    },
    'i::before': {
      color: '#FFFFFF'
    },
    button: {
      color: '#C6CCD6',
      backgroundColor: '#FFFFFF',
      cursor: 'not-allowed',
      
      '&:focus': {
        color: '#C6CCD6',
      },
      
      '&:hover' : {
        color: '#C6CCD6',
      }
    }

  }}

  ${props => props.status === 'active' && {
    border: '1px solid var(--accent-success-color)'
  }};

  @media (max-width: 992px) {
    padding: 2rem 1.5rem .8rem;
  }
 
`;

export const UserImageWrapper = styled.div`
  width: 97px;
  height: 97px;
  min-width: 97px;
  padding: 5px;
  border-radius: 50%;
  border: 1px solid rgba(108, 140, 191, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserImage = styled.div`
  width: 87px;
  height: 87px;
  min-width: 87px;
  border-radius: 50%;
  border: 1px solid rgba(108, 140, 191, 0.3);
  overflow: hidden;
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const UserName = styled.h3`

`;
